export type PublicDeliveryInfo = {
  address: string;
  phone: string;
  reference: string;
};

export function isMissingDeliveryAddress(address: string): boolean {
  const trimmed = address.trim();
  return !trimmed || trimmed === 'Direccion no registrada';
}

export type CartItem = {
  id: string;
  name: string;
  quantity: number;
  unitPrice: number;
  icon?: string;
  image?: string;
};

export type CategoryKey = 'cuidadoPersonal' | 'belleza' | 'cuidadoBebes' | 'bienestar' | 'farmacia';

export type CategoryItem = {
  key: CategoryKey;
  name: string;
  icon: string;
};
